// Landing Page
export const LANDINGPAGE_HEADER = 'QUALITY MATRIX';
export const CARDITEMLIST = [
  // { Item: 'STANDARD INSTRUCTION', id: 'instruction', img: 'STANDARD-INSTRUCTION' },
  // { Item: 'FACTORY CONFIGURATION', id: '', img: 'FACTORY-CONFIGRATION' },
  // { Item: 'CONFIGURATOR', id: '', img: 'CONFIGRATOR' },
  // { Item: 'INCIDENT DATA UPLOAD', id: '', img: 'INCIDENT-DATA-UPLOAD' },
  // { Item: 'FACTORY CONFIGURATION', id: 'factoryconfig', img: 'FACTORY-CONFIGRATION' },
  // { Item: 'CONFIGURATOR', id: 'losstree', img: 'CONFIGRATOR' },
  // { Item: 'INCIDENT DATA UPLOAD', id: 'files', img: 'INCIDENT-DATA-UPLOAD' },
  { Item: 'QUALITY MATRIX 2.1', id: 'qualitymatrixdata', img: 'INCIDENT-DATA-UPLOAD' },
  // { Item: 'QA MATRIX CREATION', id: 'QAmatrix', img: 'QA-MATRIX-CREATION' },
  // { Item: 'DASHBOARD', id: '', img: 'DASHBOARD' }
];

// Header
export const TITLEHEADER_BOLD = 'Quality';
export const TITLEHEADER = 'Matrix';
export const HEADERINFO = [
  { item: 'BANGALORE', img: 'Factory_Small_Gray' },
  { item: 'ENGLISH', img: 'Language_Gray' },
  { item: 'EURO', img: 'Curency_Gray' }
];

// Side-menu-bar
export const MENUITEMLIST = [
  { Item: 'INSTRUCTIONS', id: 'instruction', img: 'icn-instruciton' },
  // { Item: 'FACTORY CONFIGURATION', id: 'factoryconfig', img: 'FactoryConfigration_Gray' },
  // { Item: 'CONFIGURATOR', id: 'losstree', img: 'Configurator_Gray' },
  // { Item: 'INCIDENT DATA UPLOAD', id: 'files', img: 'Incident-Data-Upload_Gray' },
  { Item: 'INCIDENTS DATA', id: 'qualitymatrixdata', img: 'icn-data' },
  { Item: 'DATA UPLOAD', id: 'filesSQL', img: 'icn-excel' },
  { Item: 'DASHBOARD', id: 'dashboardsql', img: 'dashboard' },
  { Item: 'PROJECT STATUS REPORT', id: 'projectstatusreport', img: 'status-report' },
  { Item: 'COMPARATIVE ANALYTICS', id: 'qualitymatrixanalytics', img: 'qa_analysis' },
  { Item: 'DPI REDUCTION ANALYTICS', id: 'dpireductionanalysis', img: 'qa_analysis' },
  { Item: 'DATA UPLOAD STATUS', id: 'datauploadstatus', img: 'status-report' },
  { Item: 'EXCHANGE RATE', id: 'currencyexchange', img: 'currency_exchange_rate' },
  { Item: 'DELETE HISTORY', id: 'deletehistory', img: 'deleted_history' },
  // // { Item: 'QA MATRIX CREATION', id: 'QAmatrix', img: 'QA-Matrix-Creation_Gray' },
  // { Item: 'DASHBOARD', id: '', img: 'Dashboard_Gray' },
  // { Item: '', id: '1', img: 'noImg' }
];
export const MENUITEMLIST1 = [
  { Item: 'INSTRUCTIONS', id: 'instruction', img: 'Standard-Instructions_Gray' },
  // { Item: 'FACTORY CONFIGURATION', id: 'factoryconfig', img: 'FactoryConfigration_Gray' },
  // { Item: 'CONFIGURATOR', id: 'losstree', img: 'Configurator_Gray' },
  // { Item: 'INCIDENT DATA UPLOAD', id: 'files', img: 'Incident-Data-Upload_Gray' },
  { Item: 'INCIDENTS DATA', id: 'qualitymatrixdata', img: 'icn-data' },
  { Item: 'DATA UPLOAD', id: 'filesSQL', img: 'Incident-Data-Upload_Gray' },
  // { Item: 'QA MATRIX CREATION', id: 'qamatrix', img: 'QA-Matrix-Creation_Gray' },
  { Item: 'DASHBOARD', id: 'dashboardsql', img: 'Dashboard_Gray' },
  { Item: 'PROJECT STATUS REPORT', id: 'projectstatusreport', img: 'FactoryConfigration_Gray' },
  { Item: 'EXCHANGE RATE', id: 'currencyexchange', img: 'Configurator_Gray' },
  { Item: 'DELETE HISTORY', id: 'deletehistory', img: 'FactoryConfigration_Gray' },
  // { Item: 'DASHBOARD', id: '', img: 'Dashboard_Gray' },
  { Item: '', id: '1', img: 'noImg' }
];
export const MENUITEMLIST2 = [
  { Item: 'INSTRUCTIONS', id: 'instruction', img: 'icn-instruciton' },
  // { Item: 'FACTORY CONFIGURATION', id: 'factoryconfig', img: 'FactoryConfigration_Gray' },
  // { Item: 'CONFIGURATOR', id: 'losstree', img: 'Configurator_Gray' },
  // { Item: 'INCIDENT DATA UPLOAD', id: 'files', img: 'Incident-Data-Upload_Gray' },
  { Item: 'INCIDENTS DATA', id: 'qualitymatrixdata', img: 'icn-data' },
  { Item: 'DATA UPLOAD', id: 'filesSQL', img: 'icn-excel' },
  // { Item: 'QA MATRIX CREATION', id: 'QAmatrix', img: 'QA-Matrix-Creation_Gray' },
  // { Item: 'DASHBOARD', id: '', img: 'Dashboard_Gray' },
  { Item: 'DASHBOARD', id: 'dashboardsql', img: 'dashboard' },
  { Item: 'PROJECT STATUS REPORT', id: 'projectstatusreport', img: 'status-report' },
  { Item: 'COMPARATIVE ANALYTICS', id: 'qualitymatrixanalytics', img: 'qa_analysis' },
  { Item: 'DPI REDUCTION ANALYTICS', id: 'dpireductionanalysis', img: 'qa_analysis' },
  { Item: 'DATA UPLOAD STATUS', id: 'datauploadstatus', img: 'status-report' },
  { Item: 'EXCHANGE RATE', id: 'currencyexchange', img: 'currency_exchange_rate' },
  { Item: 'DELETE HISTORY', id: 'deletehistory', img: 'deleted_history' },
  { Item: '', id: '1', img: 'noImg' }
];

// factory Configurator page
export const CLUSTERSDATA: any[] = [
  { name: 'Europe', value: 'europe' },
  { name: 'Nametrub', value: 'trub' },
  { name: 'LATAM', value: 'latam' },
  { name: 'S Asia', value: 's asia' },
  { name: 'A Asia', value: 'a asia' },
  { name: 'SEAA', value: 'seaa' }
];
export const CLUSTER = 'Cluster';
export const FACTORY = 'Factory';
export const CATEGORY = 'Category';
export const SUB_CATEGORY = 'Sub Category';
export const LINEID = 'Line';
export const FACTORYCONFIGURATION = 'FACTORY CONFIGURATION';
export const CATEGORIESDATA: any[] = [
  { name: 'Food & Refreshments', value: 'food' },
  { name: 'Personal Care', value: 'pc' },
  { name: 'Home Care', value: 'hc' }
];
export const FACTORIESDATA: any[] = [
  { name: 'Leeds', value: 'leeds' },
  { name: 'Mangalore', value: 'mangalore' },
  { name: 'Bangalore', value: 'bangalore' }
];
export const SUBCATEGORIESDATA: any[] = [
  { name: 'Roll-ons', value: 'Roll-ons' },
  { name: 'Spray', value: 'Spray' }
];

// Incident Data Upload page
export const INCIDENTTYPEDATA: any[] = [
  { name: 'ABC Incident', value: 'ABC' },
  { name: 'D Incident', value: 'D' }
];
export const INCIDENTTYPE = 'Incident Type';
export const INCIDENTUPLOAD = 'Excel File Upload';
export const VIEWDASHBOARD = 'View Dashboard';
export const INCIDENTDATAUPLOAD = 'INCIDENT DATA UPLOAD';
export const INCIDENTDATAUPLOADSQL = 'Quality Matrix - Excel File Upload';
export const EXCHANGERATEUPLOAD = 'Upload Exchange Rate';
export const COLUMNNAMES = ['SINo', 'FileName', 'UploadedDate', 'UploadedBy', 'IncidentType', 'Status', 'Dashboard'];
export const COLUMNNAMESSQL = ['SINo', 'FileName', 'UploadedCurrency', 'UploadedDate', 'UploadedBy', 'Status', 'Error Details'];
export const DEFECTCLASS = ['DPI Defect Class', 'Count'];
export const INCIDENCE = ['Level(0) incidences', 'Count'];
export const DEFECTCOST = ['Detectability Category', 'Total Defect Cost Per Category'];
export const EXCHANGERATECOLUMNS = ['BU/Sub Region', 'Country', 'Site', 'Currency Unit', 'Currency Code', 'Euro Exchange Rate'];
export const DEFECTMODE = ['Defect MODE Aggregation (Level 1+2+3+4)', 'Level0', '4Ms', 'BU/Sub Region', 'Sites', 'Business Group', 'Production line', 'Defect Priority Index', 'PDCA Status', 'Occurances', 'Agreement', 'Remarks'];
export const PROJECTSTATUSREPORT = ['Modification Date', 'BU/Sub Region', 'Site', 'Business Group', 'Loss Tree', 'Level0', '4Ms', 'RecordID', 'Production Line', 'Defect Priority Index', 'PDCA Status', 'Occurances', 'Agreement', 'Remarks', 'User'];
export const LOSTTREECOLUMS = ['Loss Tree', 'Defect Priority Index', 'Occurances', 'Defect Cost in Euro'];
export const COMPARATIVEANALYSISCOLUMS = ['Level0', 'losstreecalt', 'subregion', 'Site', 'Business Group', 'Sub Category', 'Product Description', 'Defect Cost in Euro', 'fourms', 'H1 defectpriorityindex', 'H2 defectpriorityindex', 'Change ChangeDPI', 'H1 occurances', 'H2 occurances', 'Change ChangeOCCURANCES'];
export const COMPARATIVEANALYSISYOYCOLUMS = ['Level0', 'losstreecayoy', 'subregion', 'Site', 'Business Group', 'Sub Category', 'Product Description', 'Defect Cost in Euro', 'fourms', 'Y1 defectpriorityindex', 'Y2 defectpriorityindex', 'Change ChangeDPI', 'Y1 occurances', 'Y2 occurances', 'Change ChangeOCCURANCES'];
export const COMPARATIVEANALYSISHYCOLUMS = ['Level0', 'losstreecahy', 'subregion', 'Site', 'Business Group', 'Sub Category', 'Product Description', 'Defect Cost in Euro', 'fourms', 'RHY defectpriorityindex', 'THY defectpriorityindex', 'Change ChangeDPI', 'RHY occurances', 'THY occurances', 'Change ChangeOCCURANCES'];
export const CONSOLIDATECOMPARATIVEANALYSISCOLUMS = ['level0', 'defectmodeaggregation', 'subregion', 'sites', 'Business Group', 'fourms',
'occurancesY1', 'occurancesY2', 'defectpriorityindexY1', 'defectpriorityindexY2', 'changeindpiYoY', 'occurancesH1Y1', 'occurancesH1Y2', 'defectpriorityindexH1Y1', 'defectpriorityindexH1Y2', 'changeindpiH1', 'occurancesH2Y1', 'occurancesH2Y2', 'defectpriorityindexH2Y1', 'defectpriorityindexH2Y2', 'changeindpiH2'];
export const PROCESSPARETOCOLUMNS = ['Process Point', 'Defect Priority Index'];
export const PARETOCOLUMNS = ['Loss Tree', 'Defect Priority Index'];

export const DPIREDUCTIONCOLUMS = ['Loss Tree', 'Level0', 'GroupOneDPI', 'GroupTwoDPI', 'DPI Reduction Percentage'];
export const DATAUPLOADSTATUSCOLUMS = ['subregion', 'Total No of Sites', 'No of Site Uploaded Data', 'Data Upload Percentage'];
export const DATAUPLOADCLUSTERCOLUMS = ['subregion', 'Site', 'Business Group', 'Last Updated Date', 'Last Updated User'];
export const DELETEINCIDENTDATA = ['Select', 'PRODUCTIONDATE', 'PRODUCTCODE', 'PRODUCTDESCRIPTION', 'BU/SUB REGION', 'DEFECTMODEAGGREGATION', 'BIGCATEGORY', 'SUBCATEGORY', 'RECORDID', 'FORMATSIZE', 'LOSSTREE', 'LEVEL0', 'LEVEL1', 'LEVEL2', 'LEVEL3', 'LEVEL4', 'LEVEL5', 'DEFECTSEVERITYGRADE',
  'PRODUCTIONLINE', 'NOOFBLOCKEDPRODUCT', 'AVERAGEBATCHQTY', 'UOM', 'AFFECTEDPRODUCTPERCENTAGE', 'FREQUENCYSCORE', 'PROCESSPOINT', 'FOURMS', 'DETECTIONPOINT', 'DETECTABILITY', 'EINCIDENT', 'REWORK', 'AMBERCRQS', 'QUALITYRELATEDWASTE', 'DINCIDENTS',
  'PALLETNONCONFORMANCE', 'CUSTOMERNONCONFORMANCE', 'ONSHELFCRQS', 'CONSUMERCOMPLAINTS', 'MARKETPLACEINCIDENT', 'COSTOF1PC', 'TOTALDEFECTCOST', 'TOTALCOSTPERCENTAGE', 'COSTSCORE', 'DETECTABILITYINDEX', 'SEVERITYINDEX', 'FREQUENCYINDEX', 'COSTINDEX',
  'DEFECTPRIORITYINDEX', 'DPIVSTOTALDPIPERCENTAGE', 'CUMMULATIVEDPI', 'DPIDEFECTCLASS', 'MAN', 'MACHINE', 'METHOD', 'MATERIAL', 'PDCASTATUS', 'SITES', 'LOCALCURRENCY', 'TOTALDEFECTCOSTEURO'];
export const QUALITYMATRIXINCIDENTDATA = ['productiondate', 'productcode', 'productdescription', 'MaterialType', 'defectmodeaggregation', 'PackaginMaterialLevel', 'bigcategory', 'subcategory', 'recordid', 'defecttypecode', 'losstree', 'leveL0', 'leveL1', 'leveL2', 'leveL3', 'leveL4', 'leveL5', 'defectseveritygrade',
'productionline', 'noofblockedproduct', 'averagebatchqty', 'uom', 'affectedproductpercentage', 'frequencyscore', 'processpoint', 'fourms', 'detectionpoint', 'detectability', 'eincident', 'rework', 'ambercrqs', 'qualityrelatedwaste', 'dincidents', 'palletnonconformance', 'customernonconformance',
'onshelfcrqs', 'consumercomplaints', 'marketplaceincident', 'costoF1PC', 'totaldefectcost', 'totalcostpercentage', 'costscore', 'detectabilityindex', 'severityindex', 'frequencyindex', 'costindex', 'defectpriorityindex', 'pdcastatus'];
export const DPIDEFECTCLASSSELECT = ['A', 'B', 'C', 'D'];
export const DELETEHISTORY = ['FileName', 'RecordCount', 'DeletedUser', 'DeletedDate'];
export const DEFECTSEVERITYSELECT = ['A', 'B', 'C', 'D'];
export const ERRORDETAILSSQL = ['RowNo', 'Reason', 'Status'];
export const FILE_VALIDATION_MESSAGE = 'Please upload files with .xls or .xlsx format only.';
export const FILENAME_VALIDATION_MESSAGE = 'Selected Incidence file does not belong to the BU/ Sub Region, Site, Business Group which is selected or invalid filename. Please check.';
export const SELECT_INCIDENT_VALIDATION_MESSAGE = 'Please select Incident Type before uploading.';
export const API_ERROR_MESSAGE = 'Error in proccessing data. Please try again.';
export const FILE_UPLOAD_SUCCESS_MESSAGE = 'File is uploaded successfully.';
export const NO_RECORDS = 'No records found.';
export const FILE_UPLOAD_STATUS = ['Success', 'Partial Success', 'Failure'];

// Configurator page
export const LOSSTREE_HEADER = 'LOSS TREE CONFIGURATOR';
export const DEFAULT_SEVERITY = 'select';
export const GRADES = [
  { text: 'A' },
  { text: 'B' },
  { text: 'C' },
  { text: 'D' }
];
export const COLUMNS = [
  { id: 1, headerText: 'Level 0', contentAlignment: 'center', headerAlignment: 'center', width: 165, fixed: true },
  { id: 2, headerText: 'Level 1', headerAlignment: 'center', width: 80 },
  { id: 3, headerText: 'Level 2', headerAlignment: 'center', width: 80 },
  { id: 4, headerText: 'Level 3', headerAlignment: 'center', width: 80 },
  { id: 5, headerText: 'Level 4', headerAlignment: 'center', width: 80 },
  { id: 6, headerText: 'Level 5', headerAlignment: 'center', contentAlignment: 'center', width: 80 },
  { id: 7, headerText: 'Aggregation', headerAlignment: 'center', width: 180 },
  { id: 8, headerText: 'Severity Grade', headerAlignment: 'center', contentAlignment: 'center', width: 85 },
  { id: 9, headerText: 'Explanation/Examples', headerAlignment: 'center', contentAlignment: 'center', width: 150 },
  { id: 10, headerText: 'Actions', headerAlignment: 'center', contentAlignment: 'center', width: 80 }
];
export const SUCCESSMSG = ' Your changes have been saved successfully.';
export const ERRORMSG = 'Error in processing data. Reason: "';

// QA-matrix page (5 tabs)
export const QAHEADER = 'QA MATRIX CREATION';
export const FIRST_TABTITLE = 'Defect Mode / Severity';
export const SECOND_TABTITLE = 'Frequency';
export const THIRD_TABTITLE = 'Cost';
export const FOURTH_TABTITLE = 'Detectability';
export const FIFTH_TABTITLE_DPI = 'DPI Calculations &';
export const FIFTH_TABTITLE_PDCA = 'PDCA Status';
export const DEFECT_TYPE = 'DEFECT TYPE';

// defect-mode tab (datatable)
export const DEFECTMODECOLUMNSNAME = ['productionDate',
  'productCode', 'formatAggregation', 'format', 'airswebId', 'description', 'defectAggregation', 'severityGrade'];
export const PRODUCTION = 'Production';
export const DATE = 'Date';
export const PRODUCT = 'Product';
export const CODE = 'Code';
export const FORMAT_AGGREGATION = 'Sub-Category + Product';
export const AIRSWEB_ID = 'Airsweb ID';
export const DESCRIPTION = 'Name';
export const DEFECT_AGGREGATION = 'Defect Mode Aggregation(Level 1+2+3+4)';
export const DEFECT_SEVERITY = 'Defect Severity';
export const GRADE = 'Grade';
export const FORMAT = 'Pack Size';

// Frequency tab (datatable)
export const FREQUENCYCOLUMNSNAME = ['productionDate', 'formatAggregation', 'blockedproduct',
  'ProductionAmount', 'UoM', 'affectedProduct', 'frequencyScore'];
export const BLOCKEDPRODUCT_NO = '# of Blocked Product';
export const TOTAL_PRODUCTION_AMOUNT = 'Total Production Amount';
export const AVERAGE_BATCH = '(Average Batch)';
export const UOM = 'UoM (Pcs-Kgs-Pallets-Cases-Cus)';
export const PERCENTAGE_AFFECTEDPRODUCT = '% of Affected Product';
export const FREQUENCY_SCORE = 'Frequency Score';

// Cost tab
export const COSTCOLUMNSNAME = ['productionDate', 'formatAggregation',
  'cost1piece', 'totaldefectcost', '%fromtotalcost', 'costscore'];
export const COSTSCORE = 'Cost Score';
export const FROMTOTALCOST = '% from Total Cost';
export const COST1PIECE = 'Cost of 1 Piece';
export const TOTALDEFECTCOST = 'Total Defect Cost';

// detection point tab
export const DETECTIONPOINTCOLUMNSNAME = ['productionDate', 'formatAggregation',
  'occurance', 'ms', 'criticalComponent', 'detectionType', 'detectionpoint', 'detectability'];
export const DETECTABILITY = 'Detectability';
export const MS = '4Ms';
export const DETECTIONPOINT = 'Detection Point';
export const OCCURANCE = 'Occurance';
// export const VALUES = ['RO Capper', 'Labeler', 'Palletisator', 'Valve Sorter']; to be removed once getting Api
export const VALUES = ['Freezer 90-1', 'Freezer 90-2', 'Freezer 91-1', 'Freezer-91-2', 'Kuka Robot L22', 'Tunnel',
  'X-Ray', 'Pallettizzatore', 'Checkweigher', 'HANDLING FANTINI', 'BigDrum', 'Formatrice Nuova', 'Formatrice Vecchia',
  'Vortex', 'Chiuditrice Lato 23', 'Chiuditrice LMuro', 'Mannara Lato 24', 'Mannara Lato Muro'];
export const DETECTIONPOINTVALUES = ['E incidents (Supplier)', 'Rework, Amber CRQS, waste', 'Manufacturing Quality Incidents', 'Customer Claims', 'On-shelf CRQS,  point of sale', 'Market Place Incident (A, B, C)', 'Consumer Complaint'];
export const FOURMS = ['Man', 'Machine', 'Method', 'Material'];
export const PDCASTATUSVALUES = ['Plan', 'Do', 'Check', 'Act'];
export const DETECTIONTYPEVALUES = ['Poka YokeError Proofing', '100% Inspection by measuring', 'Random inspection by measuring Random visual/sensory', 'check100% visual/sensory check'];

// PDCA and DPI calc tab
export const DPIANDPDCACOLUMNSNAME = ['productionDate', 'formatAggregation', 'defectPriorityIndex', 'vstotalDPI',
  'cumulativeDPI', 'dpiDefectClass', 'pdca'];
export const VSTOTALDPI = '% DPI vs Total DPI';
export const CUMMULATIVEDPI = 'Cumulative DPI';
export const DPIDEFECTCLASS = 'DPI Defect Class';
export const PDCASTATUS = 'PDCA Status';

// Standard Instruction page
export const STDPRIORITIZATION = 'STANDARD OF PRIORITIZATION';
export const PRIORITYINDEX = 'Priority Index';
export const COST = 'Cost';
export const FREQUENCY = 'Frequency';
export const DETECTABILITYINDEX = 'Detectability Index';
export const SEVERITY = 'Severity';
export const EQUALTO = '=';
export const MULITPLY = 'X';
export const STDINSTRUCTION = 'STANDARD INSTRUCTION';
export const INTERNALDETPOINTS = 'Internal Detection Points';
export const EXTERNALDETPOINTS = 'External Detection Points';
export const CLASSIFICATIONDPI = 'Classification of Defects based on DPI';

// Dashboard
export const DASHBOARD = 'DASHBOARD';
export const DASHBOARDSQL = 'QUALITY MATRIX - DASHBOARD';
export const MDISTRIBUTION = '4M Distribution';
export const PDCA = 'PDCA';
export const DPI = 'Defect Priority Index';
export const FORMULAE = '= S X F X C X ';
export const DASHBOARDCOLUMNNAMES = ['Severity Grade', 'Short Description', 'Criteria', 'Index'];
export const COSTCOLUMNNAMES = ['Criteria', 'From (%)', 'To (%)', 'Index'];
export const DETECTABILITYCOLUMNNAMES = ['Criteria', 'Index'];
export interface SeverityGrade {
  SGrade: string;
  Desc: string;
  Criteria: string;
  Index: number;
}
export const DASHBOARDVALUE = '--Select--';
export const DASHBOARDINFO: any[] = [
  { name: 'lossTree', value: 'LossTree v/s DPI' },
  { name: 'Process', value: 'LossTree v/s Machines' }
];
export const SGTABLEDATA: SeverityGrade[] = [
  { SGrade: 'A', Desc: 'Critical Issues', Criteria: 'Customer Safety T5Z', Index: 500 },
  { SGrade: 'B', Desc: 'Major Issues', Criteria: 'Legal and Regulatory (No fatal issues)', Index: 100 },
  { SGrade: 'C', Desc: 'Serious Issues', Criteria: 'Likely to be noticed', Index: 50 },
  { SGrade: 'D', Desc: 'Minor Issues', Criteria: 'Likely not be noticed', Index: 10 }
];
export const FREQTABLEDATA = [
  { Criteria: 'Very High', From: '>6.68', To: '<100', Index: 500 },
  { Criteria: 'High', From: '>0.621', To: '<50', Index: 200 },
  { Criteria: 'Moderate', From: '>0.0233', To: '<25', Index: 100 },
  { Criteria: 'Low', From: '>=0', To: '<1', Index: 50 }
];
export const COSTTABLEDATA = [
  { Criteria: 'Loss Cost', From: '500', To: '<100', Index: 500 },
  { Criteria: 'Loss Cost', From: '200', To: '<50', Index: 200 },
  { Criteria: 'Loss Cost', From: '100', To: '<25', Index: 100 },
  { Criteria: 'Loss Cost', From: '75', To: '<1', Index: 50 }
];
export const CLASSIFICATIONTABLEDATA = [
  { value: 'A=<50%' }, { value: 'B>50%<=70%' }, { value: 'C>70%<=90%' }, { value: 'D>90%' }
];
export const INTERNALDPTABLEDATA = [
  { value: 'E Incidents (Supplier)' }, { value: 'Rework' }, { value: 'Amber CRQS' }, { value: 'Waste' }, { value: 'Manufacturing Quality Incidents' }
];
export const EXTERNALDPTABLEDATA = [
  { desc: 'Distribution', value: 'Pallet Q non-conformance' },
  { desc: 'Customer', value: 'Customer Q non-conformance' },
  { desc: 'Consumer', value: 'Consumer Complaints' },
  { desc: 'Market Place Incident', value: 'Market Place incidents(A,B,C Incidents)' },
  { desc: 'Storage on the shelf', value: 'On-shelf CRQS, point of sale' }
];

// API Related
// export const SUBSCRIPTIONKEY = '1353f865d012425880e82426fd0e0ba5';
export const APPLICATIONCONTENT = 'application/json; charset=utf-8';
export const ACCESSCONTROL = '*';
export const SETTINGS = 'settings';
export const LOSSTREE = 'settings/factories/';
export const STANDARDINSTRUCTIONS = 'incidents/GetStandardInstructions';
export const FILEUPLOAD = 'incidents/files/';
export const FILEUPLOADSQL = 'incidents/filesSQL/';
export const GETSQLFILEDETAILS = 'incidents/getfilesSQL/';
export const GETCURRENCYLIST = 'incidents/getcurrency';
export const GETUPLOADERRORDETAILS = 'incidents/getErrorLog/';
export const LOSSTREEEDIT_GETFILES = 'incidents/files';
export const QAMATRIXDATA = 'qaMetrices/';
export const SAVEQAMATRIXDATA = 'qaMetrices/';
export const MACHINELIST = 'machines';
export const DFOSMENUITEMS = 'menuitems';
export const DFOSCATEGORYMENUITEMS = 'linedetails/regions/';
export const DFOSFACTORIESURL = '/factories/';
export const DFOSLINEIDURL = '/lines/';
export const DFOSSAVEFACTORYCONFIGURATION = 'settings/factoryConfig';
// export const DFOSCATEGORYSUBCATEGORYCLUSTERURL = '/filterdatas/';
// export const DFOSFACTORYURL = '/factory/';
export const GETDASHBOARDSQLDATA = 'incidents/getdashboarddata';
export const GETDASHBOARDCHARTSSQLDATA = 'incidents/getdashboardchartsdata';
export const GETCATEGORYSUBCATEGORY = 'GetSkuCategoryData';
export const GETCLUSTERBASEDONROLE = 'menuitems';
export const GETCLUSTERFACTORY = 'collectionName/clusters';
export const GETCLUSTERSITEBIGCATEGORY = 'incidents/getfilterdata';
export const INSERTAGREEMENT = 'incidents/insertagreement';
export const GETPIVOTTABLEDETAILS = 'incidents/getagreement';
export const GETALLINCIDENTDATABYFILEID = 'incidents/getallincidentdatabyfileid/';
export const GETDELETEHISTORY = 'incidents/getdeletehistory';
export const DELETEINCIDENTDATAS = 'incidents/deleteincidentdata';
export const UPLOADSTATUS = 'GetFreezeUploadStatus';
export const SAVESTATUS = 'PostFreezeUploadData';
export const GETPROCESSPARETOREPORTURL = 'incidents/GetProcessParetoReport';
export const GETPARETOREPORTURL = 'incidents/GetParetoReport';
export const DEFECTCLASSVALUES: any[] = [
  { name: 'A', value: 'A' },
  { name: 'B', value: 'B' },
  { name: 'C', value: 'C' },
  { name: 'D', value: 'D' }
];
export const LOSSTREECOLUMNNAMES = ['Level0', 'Level1', 'Level2', 'Level3', 'Level4', 'Level5', 'Aggregation', 'Severity Grade',
  'Explanation/Examples'];
export const POSTLOSTTREESTATS = 'incidents/postqualitymatrix';
export const POSTCOMPARATIVEANALYSISSTATS = 'incidents/postcomparativematrix';
export const POSTCOMPARATIVEANALYSISYOY = 'incidents/postcomparativematrixyearofyear';
export const POSTCOMPARATIVEANALYSISHALFYEARLY = 'incidents/postcomparativematrixhalfyearly';
export const GETINCIDENTSDATA = 'incidents/GetIncidentsData';
export const GETDPIREDUCTIONANALYSIS = 'incidents/GetDpiReductionAnalysisReport';
export const GETINCIDENTDATAUPLOADSTATUS = 'incidents/GetIncidentDataUploadStatus';
export const GETINCIDENTDATAUPLOADCLUSTERDETAILS = 'incidents/GetIncidentDataUploadClusterDetails';
// appcomponent, QA-Matrix User roles
export const ROLES = ['QGA', 'QAM-QC', 'QGR', 'QAM-FU'];
export const DASHBOARDTABS = ['Pivot Table', 'Defect Pareto', 'Process Pareto'];
export const ANALYSISTABS = ['Loss Tree', 'Comparative Analysis - Loss Tree', 'Comparative Analysis - Year on Year (YoY)', 'Comparative Analysis - Half Yearly'];
